import axios from 'axios';
import {backendHost} from '../../config';

export const postGroupOffer = (params) => {
    return axios.post(`${backendHost}/api/partners/admin/group-offer`, params);
};